import { Password } from "primereact/password";
import {
  Controller,
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface Password2FormData extends FieldValues {
  password2: string;
}

type Password2Props<T extends Password2FormData> = {
  form: UseFormReturn<T, any, T>;
  required: boolean;
};

export function Password2Field<T extends Password2FormData>({
  form,
  required = true,
}: Password2Props<T>) {
  const { t } = useTranslation();

  const error = form.formState.errors.password2 as
    | Record<string, any>
    | undefined;

  return (
    <>
      <Controller
        name={"password2" as Path<T>}
        control={form.control}
        rules={{
          required: required && t("Error.Required"),
          minLength: {
            value: 6,
            message: t("Error.MinLength", { value: 6 }),
          },
          validate: (value) =>
            value === form.getValues("password" as Path<T>) ||
            t("Error.NotEqualPassword"),
        }}
        render={({ field }) => (
          <Password
            inputId="password2"
            {...field}
            feedback={false}
            toggleMask
            className="w100"
            inputClassName="w100"
            invalid={!!error}
          />
        )}
      />
      {error && <small className="p-error block">{error.message}</small>}
    </>
  );
}
